import React, { ReactElement } from 'react';
import type { Route } from 'next';
import dynamic from 'next/dynamic';
import classNames from 'classnames/bind';
import RootLayout from 'layouts/RootLayout';
import proxyAxios from 'api/proxyAxios';
import { endpoints } from 'api/endpoints';
import { TopArticlesCardType } from 'sections/Home/types';
import Breadcrumbs from 'components/Breadcrumbs';
import 'swiper/css';
import styles from 'pages/resources/demurrage-and-detention/DemurrageAndDetention.module.scss';

const cn = classNames.bind(styles);

const SectionHeader = dynamic(() => import('sections/Resources/DemurrageAndDetention/components/SectionHeader/'));
const SectionCharges = dynamic(() => import('sections/Resources/DemurrageAndDetention/components/SectionCharges/'));
const SectionTime = dynamic(() => import('sections/Resources/DemurrageAndDetention/components/SectionTime/'));
const SectionUnderstanding = dynamic(() => import('sections/Resources/DemurrageAndDetention/components/SectionUnderstanding/'));
const SectionFactors = dynamic(() => import('sections/Resources/DemurrageAndDetention/components/SectionFactors/'));
const SectionStrategies = dynamic(() => import('sections/Resources/DemurrageAndDetention/components/SectionStrategies/'));
const SectionBenefit = dynamic(() => import('sections/Resources/DemurrageAndDetention/components/SectionBenefit/'));
const SectionFeatures = dynamic(() => import('sections/Resources/DemurrageAndDetention/components/SectionFeatures/'));
const SectionKey01 = dynamic(() => import('sections/Resources/DemurrageAndDetention/components/SectionKey01/'));
const SectionImpact = dynamic(() => import('sections/Resources/DemurrageAndDetention/components/SectionImpact/'));
const SectionKey02 = dynamic(() => import('sections/Resources/DemurrageAndDetention/components/SectionKey02/'));
const SectionTrucking = dynamic(() => import('sections/Resources/DemurrageAndDetention/components/SectionTrucking/'));
// (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
// const SectionSignUp = dynamic(() => import('sections/Resources/DemurrageAndDetention/components/SectionSignUp/'));
const SectionFaq = dynamic(() => import('sections/Resources/DemurrageAndDetention/components/SectionFaq/'));
// (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
// const SectionCallToAction = dynamic(() => import('sections/Resources/DemurrageAndDetention/components/SectionCallToAction/'));
const SectionRelatedPosts = dynamic(() => import('sections/Resources/DemurrageAndDetention/components/SectionRelatedPosts/'));

interface IProps {
  articles: TopArticlesCardType[];
}

export default function DemurrageAndDetention({ articles }: IProps) {
  return (
    <div className={cn('demurrage-and-detention')}>
      <div className={cn('container')}>
        <Breadcrumbs mTop={64} mode="light" links={[{ title: 'Demurrage and Detention', href: '' as Route }]} />
      </div>
      <SectionHeader />
      <SectionCharges />
      <SectionTime />
      <SectionUnderstanding />
      <SectionFactors />
      <SectionStrategies />
      <SectionBenefit />
      <SectionFeatures />
      <SectionKey01 />
      <SectionImpact />
      <SectionKey02 />
      <SectionTrucking />
      {/* (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774) */}
      {/* <SectionSignUp /> */}
      <SectionFaq />
      {/* (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774) */}
      {/* <SectionCallToAction /> */}
      <SectionRelatedPosts articles={articles}/>
    </div>
  );
}

export const getStaticProps = async () => {
  const meta = {
    title: 'What is Demurrage & Detention Charges | DF Alliance',
    description:
      'Learn about demurrage and detention policies with DF Alliance to better understand the cost management aspects of global freight forwarding.',
    path: '/resources/demurrage-and-detention',
  };
  try {
    const { data: articles } = await proxyAxios(endpoints.blog.previewArticles + '?limit=3');

    return { props: { articles, ...meta } };
  } catch (e) {
    console.log('endpoints.blog.previewArticles', e);
  }
  return {
    props: {
      articles: [],
      ...meta,
    },
  };
};

DemurrageAndDetention.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
